import React from 'react';
import { Edit } from 'react-admin';
import { QualificationTitle } from '../Course/QualificationTitle';
import { AssociateCourseInputs } from './AssociateCourseInputs';

export const AssociateCourseEdit = (props) => (
    <Edit title={<QualificationTitle />} {...props} redirect="edit">
        <AssociateCourseInputs {...props} />
    </Edit>
);
